import type { Brand } from '@pdcfrontendui/types';
import { DayMessage } from '@pdcplan/shared/api/Message';
import { MsgVisibilityOldEnum } from '@pdcplan/shared/enums';
import { ChatType, RouteEnum, type RouteState } from '../routes';
import type { ShiftMap } from '../api/model';

export type ChatKey = Brand<string, 'ChatKey'>;
// Length is at least 1
export type DayMessageMap = Record<ChatKey, DayMessage[] & { 0: DayMessage }>;

export function getChatKey(
  personId: number,
  date: Date,
  Visibility: MsgVisibilityOldEnum
): ChatKey {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  return `${year}${month}${day}-${personId}-${
    Visibility === MsgVisibilityOldEnum.planner ? 'private' : 'employee'
  }` as ChatKey;
}

export function getChatKeyFromRoute(
  routeState: RouteState | null,
  shiftMap: Record<string, ShiftMap>
): ChatKey | null {
  switch (routeState?.route) {
    case RouteEnum.Chat:
      return routeState.params.thread ?? null;
    case RouteEnum.Team: {
      if (
        routeState.params.personId !== undefined &&
        routeState.params.shiftId !== undefined &&
        routeState.params.chat !== undefined &&
        shiftMap[routeState.teamId]?.[routeState.params.shiftId]
      ) {
        return getChatKey(
          routeState.params.personId,
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- Already checked above
          shiftMap[routeState.teamId]![routeState.params.shiftId]!.period.from,
          routeState.params.chat === ChatType.Employee
            ? MsgVisibilityOldEnum.employee
            : MsgVisibilityOldEnum.planner
        );
      }
      return null;
    }
    default:
      return null;
  }
}
